// extracted by mini-css-extract-plugin
module.exports = {"PhotoCropInput":"bgb_a","ReactCrop--disabled":"bgb_b","ReactCrop--circular-crop":"bgb_c"};